<script setup lang="ts">
/**
 * filters the search definitions for printable ones and gives the
 * most sensible ordering (text query first, then other filters
 */
import crystalBallIcon from "~/assets/icons/pill/crystal-ball.svg"

const props = defineProps({
  search: null
})

const facets = computed(() => {
  const definition = props.search.definition()
  if (isDefined(definition)) {
    let facets = definition.facets
    // if we have a "contains" and a "starts-with" filter we remove the starts-with
    const hasContains = any(definition.facets, f => "contains" in f.facetType)
    const hasStartsWith = any(definition.facets, f => "startsWith" in f.facetType)
    if (hasContains && hasStartsWith)
      facets = definition.facets.filter(f => !("startsWith" in f.facetType))

    // if we have more than one near filter, we remove the image and video text filters
    // since doc-like text is the most general one
    const isNearFilter = (f: SearchFacet) => (
      "nearImageText" in f.facetType
      || "nearDocLikeText" in f.facetType
      || "nearVideoText" in f.facetType
    )
    const nearFilters = definition.facets.filter(isNearFilter)
    console.log(nearFilters, definition.facets)
    if (len(nearFilters) > 1)
      facets = facets.filter(f => !isNearFilter(f) || deepEqual(f, nearFilters[0]))

    return facets
  }
  else {
    return []
  }
})

const sorts = computed(() => {
  const definition = props.search.definition()
  if (isDefined(definition))
    return definition.sorts
  else
    return []
})
</script>

<template>
  <div v-if="search.description()" class="item">
    <crystal-ball-icon class="icon" />
    <div class="description">
      {{ search.description() }}
    </div>
  </div>
  <div v-else class="item">
    <crystal-ball-icon class="icon" />
    <search-path-facet
      v-for="facet, key in facets"
      :key
      :facet
    />
    <search-path-sort
      v-for="sort, key in sorts"
      :key
      :sort
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.item
  @apply flex flex-none items-center h-full
.file-thumbnail
  @apply h-full aspect-square
.description
  @apply text-ellipses-inline
.icon
  @apply text-[#{$pill-t-default}]
</style>
